var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.822 9.875h.193l1.954-.44c.39-.077.748-.268 1.028-.549l5.3-5.3a1.16 1.16 0 00.34-.827 1.13 1.13 0 00-.34-.827L9.868.503a1.174 1.174 0 00-1.646 0l-5.408 5.27c-.28.28-.47.638-.549 1.027L1.88 8.7a.974.974 0 00.263.89c.182.177.425.28.68.285zm6.01-8.77a.324.324 0 01.456 0l1.438 1.445a.292.292 0 01.092.224.309.309 0 01-.092.225l-.92.904-1.9-1.901.927-.896zM3.093 6.97c.042-.239.158-.458.332-.626l3.863-3.786 1.909 1.916L5.41 8.3c-.16.165-.368.276-.595.317l-1.97.401a.1.1 0 01-.108 0 .116.116 0 010-.116l.355-1.931zM12.41 10.98H.758a.425.425 0 000 .85H12.41a.425.425 0 000-.85z",
    fill: "#333"
  })));
}
export default SvgEditSmall;